exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-drawer__body {\n  overflow: auto;\n}\n", ""]);

// exports
